import React, { Component } from "react";
import { createStore, applyMiddleware } from "redux";
import { Provider, connect } from "react-redux";
import reducer from "../../reducers/top/index_of_not_signed_in";
import actionCreators from "../../actions/top/index_of_not_signed_in";
import TopFeaturedCircleList from "../../components/top/top_featured_circle_list";
import NewArrivalCircleList from "../../components/top/new_arrival_circle_list";
import PopularEventList from "../../components/top/popular_event_list";
import TopReportList from "../../components/top/top_report_list";
import TopBlogList from "../../components/top/top_blog_list";
import ApplicationStoreBadge from "../../components/top/application_store_badge";

const store = createStore(reducer, applyMiddleware());

export default class TopIndexOfNotSignedIn extends Component {
  UNSAFE_componentWillMount() {
    store.dispatch(
      actionCreators.top.indexOfNotSignedIn.set(
        this.props.isWebViewTabApp,
        this.props.circles,
        this.props.newArrivalCircles,
        this.props.events,
        this.props.blogs,
        this.props.reports,
        this.props.timelineOthers,
        this.props.userAgent
      )
    );
  }

  render() {
    return (
      <Provider store={store}>
        <Root />
      </Provider>
    );
  }
}

const TmpRoot = ({ state }) => {
  return (
    <div className="timeline-container">
      <div style={{ padding: "10px 10px" }}>
        <ApplicationStoreBadge userAgent={state.userAgent} />
      </div>
      <TopFeaturedCircleList
        isWebViewTabApp={state.isWebViewTabApp}
        circles={state.circles}
      />
      <NewArrivalCircleList
        isWebViewTabApp={state.isWebViewTabApp}
        newArrivalCircles={state.newArrivalCircles}
      />
      {state.isWebViewTabApp ? (
        ""
      ) : (
        <article className="timeline-box">
          <a
            className="btn btn-info btn-md full-width g-mt-10 g-mb-20"
            href="/search"
            style={{ color: "#fff" }}
          >
            <span
              className="glyphicon glyphicon-search fs14 bold"
              aria-hidden="true"
            />{" "}
            もっとサークルを検索
          </a>
        </article>
      )}
      <PopularEventList events={state.events} />
      <TopBlogList blogs={state.blogs} />
      <TopReportList reports={state.reports} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  state,
});

const Root = connect(mapStateToProps)(TmpRoot);
